import React, { Component } from 'react';
import _ from 'lodash';
import * as Sentry from '@sentry/browser';
import { connect } from 'react-redux';
import { Route, Switch, Redirect } from 'react-router-dom';
import PrivateRoute from '../../containers/PrivateRoute/index';
import ModulesRoutingContainer, { modulePaths } from '../ModulesRoutingContainer/index';
import StudentFormContainer from '../StudentFormContainer/index';
import Sidebar from '../../components/Sidebar';
import TrackProgressRoutingContainer from '../../containers/TrackProgressRoutingContainer/index';
import HomePage from '../../pages/HomePage/index';
import Expeditions from '../../pages/Expeditions';
import { familyPaths } from '../FamilyRoutingContainer/index';
import { trackProgressPaths } from '../TrackProgressRoutingContainer/index';
import ClassManagementContainer, { routes as classManagementRoutes } from '../../pages/class_management';
import Footer from '../../components/Footer';
import StudentRegistrationForm from '../../components/StudentRegistrationForm';
import CASContainer from '../../containers/CASContainer/index';
import GoogleOAuthContainer from '../../containers/GoogleOAuthContainer/index';
import FamilyRoutingContainer from '../../containers/FamilyRoutingContainer/index';
import FamilyDashboardContainer from '../../containers/FamilyDashboardContainer/index';
import CalendarContainer, { routes as calendarRoutes } from '../../pages/calendar';
import { EmeraldHost } from '../../config';
import {Helmet} from "react-helmet";

//import contexts
import OnboardingTeacherContextProvider from '../../contexts/OnboardingTeacherContextProvider';
//import utils
import { CHILD, getCurrentRole, STUDENT } from "../../util";
//userflow.js - user onboarding tutorial software
import userflow from 'userflow.js'

// Font awesome import
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircle as farCircle } from '@fortawesome/free-regular-svg-icons'
import { faWallet, faEllipsisV, faDownload, faTimes, faCheck, faCalendarCheck, faHourglassHalf, faTrashAlt, faPlusCircle, faLeaf, faDna, faUsers, faUser, faTachometerAlt, faUserPlus, faSignOutAlt, faCog, faBars, faThLarge } from '@fortawesome/free-solid-svg-icons'
import { runQuery } from '../../fetchUtils';
library.add(faTimes, faDownload, faWallet, faEllipsisV, farCircle, faTimes, faCheck, faCalendarCheck, faHourglassHalf, faTrashAlt, faPlusCircle, faLeaf, faDna, faUsers, faUser, faTachometerAlt, faUserPlus, faSignOutAlt, faCog, faBars, faThLarge)

if(process.env.NODE_ENV != 'development'){ Sentry.init({dsn: "https://87cec7693b1148e793ebe8ffa4a5c1b1@sentry.io/5177676"}); }
class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      intercomBooted: false
    }
  }

  userIsLoggedIn = ()=> !_.isEmpty(this.props.data)

  getUserId = () => {
    if(this.userIsLoggedIn()){
      return this.props.data['uuid']
    }
  }

  getUserInfo = () => {
    if(this.userIsLoggedIn()){
      return {
        name:this.props.data['first-name'],
        email:this.props.data['email']
      }
    }
  }

  fetchIdentityVerfication_userflow = () => {
      //encrypting user_uuid with crypto for userflow user identification only
      //fetching encrypted user identity signature
      const fetchUUid_userflow_encrypt = `
        query UserflowQuery {
          currentUserflowEncryptedData{
            encryptedUserIdentifier
            userflowAccessToken
          }
        }
      `
      const fetchUUid_callback = {
        onComplete: json => {
          const data = json.data?.currentUserflowEncryptedData
            userflow.init(data.userflowAccessToken)
            userflow.identify(this.getUserId(), this.getUserInfo(), {signature:data.encryptedUserIdentifier})
        },
        onFailure: error => {console.error(error)}
      }
      runQuery(fetchUUid_userflow_encrypt,{},fetchUUid_callback)
  }

  //please note that this function is responsible for toggling the state for showing/hiding the
  //intercom bubble for STUDENT and CHILD account only.
  handleHideIntercom = () => {
    Intercom('update',{
      "hide_default_launcher":false
    })
    Intercom('show')
  }

  getEpochTime = ()=>
    parseInt((new Date()).getTime() / 1000)

  componentWillUnmount() {
    // Unbind the Intercom update listener
    this.unlisten()
  }

  componentDidUpdate() {
    if(this.userIsLoggedIn()) {
      if(!this.state.intercomBooted){
        this.setState({ intercomBooted: true })

        let userType = 'child'
        if(this.props.data['is-educator']){ userType = 'educator' }
        else if(this.props.data['is-homeschooler']){ userType = 'homeschooler' }
        else if(this.props.data['is-student']){ userType = 'student' }
  
        const fullName = this.props.data['first-name'] + ' ' + this.props.data['last-name']
  
        const config = {
          app_id:     'lkflg3qd',
          email:      this.props.data['email'],
          user_id:    this.props.data['uuid'],
          full_name:  fullName,
          type:       userType,
          created_at: this.getEpochTime(),
          //hide intercom by default if user is Student or Child
          "hide_default_launcher":getCurrentRole(this.props.data) === STUDENT || getCurrentRole(this.props.data) === CHILD
        }
        window.Intercom('boot', config);
  
        // Listen to route changes so we can update Intercom and
        // simulate a page change
        this.unlisten = this.props.history.listen((location, action) => {
          window.Intercom('update', {
            email:            this.props.data['email'],
            user_id:          this.props.data['uuid'],
            type:             userType,
            full_name:        fullName,
            last_request_at:  this.getEpochTime(),
          });
        });
      }

      if(this.props.data['is-educator'] || this.props.data['is-homeschooler']){
        /*initialize userflow on mount userflow_token comes from
        ImmersedGames' company account on userflow (different token
        for production vs staging), fetch both token and encrypted uuid
        from backend*/
        this.fetchIdentityVerfication_userflow()
      }
    }
  }
  render() {
    return (
    <OnboardingTeacherContextProvider current_user={this.userIsLoggedIn && this.props.data}>
      <div id='app'>
        {/*Identify the user so we can contact them if our front-end breaks*/}
        {this.userIsLoggedIn() && Sentry.configureScope(scope => scope.setUser({ 'email': this.props.data['email'], 'username': this.props.data['username'], 'id': this.props.data['uuid'] }) )}

        {this.userIsLoggedIn() && <Sidebar currentUser={this.props.data} />}

        <div className={`page-container ${this.userIsLoggedIn() ? 'authenticated' : 'no-auth no-padding'}`}>
          <div className="page-content-wrapper bg-app-white">
            <Helmet>
              <script>
                {`(function(c,o,v,i,e,w){c[v]=c[v]||function(){(c[v].a=c[v].a||[]).push(arguments)};var s=o.createElement(i);s.src=e;s.async=1;var h=o.getElementsByTagName(i)[0];h.parentNode.insertBefore(s,h);c.addEventListener('error',function(err){c[v]('error',err)});c.addEventListener('message',function(msg){c[v]('message',msg)})})(window,document,'coview','script','https://cdn.coview.com/coview.js');
                coview('start', {
                  projectKey:'smZ1PEyXknQ'
                });`}
              </script>
            </Helmet>
            <div className='content'>
              <Switch>
                {/* Auth-related routes */}
                <Route exact path='/users/service' component={CASContainer}/>
                <Route exact path='/auth/google_oauth2/callback' component={GoogleOAuthContainer}/>

                {/* Private, app-related routes */}
                <PrivateRoute exact path='/home' component={HomePage} componentProps={{ currentUser: this.props.data, handleHideIntercom:this.handleHideIntercom}}/>
                {_.map(trackProgressPaths, (path) =>
                  <PrivateRoute key={path} exact path={path} component={TrackProgressRoutingContainer} />
                )}
                {_.map(familyPaths, (path) =>
                  <PrivateRoute key={path} exact path={path} component={FamilyRoutingContainer} componentProps={{ children: <FamilyDashboardContainer/>}}/>
                )}
                {_.map(modulePaths, (path) =>
                  <PrivateRoute key={path} exact path={path} component={ModulesRoutingContainer} />
                )}
                {_.map(classManagementRoutes, path =>
                  <PrivateRoute key={path} exact path={path} component={ClassManagementContainer} componentProps={{ currentUser: this.props.data }}/>
                )}
                {_.map(calendarRoutes, route =>
                  <PrivateRoute key={route} exact path={route} component={CalendarContainer} componentProps={{ currentUser: this.props.data }} />
                )}
                <PrivateRoute strictlyPrivate={true} exact path='/expeditions' component={Expeditions} />
                {/* student registration should now be privately accessible only */}
                <PrivateRoute strictlyPrivate={true} exact path='/register_for_class' component={StudentFormContainer} componentProps={{ formComponent: StudentRegistrationForm }}/>

                {/* A catch-all that redirects to the home page */}
                <PrivateRoute component={Redirect} componentProps={{ to: '/home' }}/>
              </Switch>
            </div>
            <Footer />
          </div>
        </div>
      </div>
      </OnboardingTeacherContextProvider>
    );
  }
}

const mapStateToProps = (state) => {
  return state.currentUser
}

export default connect(mapStateToProps)(App)
